
import Vue from 'vue'

import 'leaflet/dist/leaflet.css';
// import { Icon } from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LPopup } from 'vue2-leaflet';

import { latLng } from "leaflet";
import Location from './location'

let iconOptions = {
  iconUrl: "./images/favicon.png", iconSize: [32,37], iconAnchor: [16, 37]
}

export default Vue.extend({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPopup,
   LIcon
  },  
  props: {
      locations: Array as () => Array<Location>,
      selectedLocation: Object as () => Location
  },
  data() {
        return {
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            map: null,
            markerObjects: null,
            center: latLng(40.641022, -73.985439),
            zoom: 13,
            // currentCenter: latLng(47.41322, -1.219482),
            // center: latLng(47.41322, -1.219482),
            mapOptions: {
                  zoomSnap: 0.5
            },
            iconUrl: `${(window as any).baseUrl}/favicon.png`, //"/images/favicon.png",
            iconSize: [32,37],
            iconAnchor: [16, 37]
        }
    },
     mounted() {
    this.$nextTick(() => {
        this.map = this.$refs.myMap;
        this.markerObjects = this.$refs.markersRef.map(ref => ref.mapObject);
      });
    },
    watch: {
      selectedLocation: function () {
        if (this.selectedLocation) {
          this.center = latLng(this.selectedLocation.lat, this.selectedLocation.lng);
          this.displayPopup(this.selectedLocation);
        }
      }
    },
    methods: {
      displayPopup: function (loc: Location) {
        for (let index = 0; index < this.markerObjects.length; index++) {
          const mo = this.markerObjects[index];
            if (mo._latlng.lat == loc.lat && mo._latlng.lng == loc.lng) {
              mo.openPopup();
              
            break;
          }
        }
      }
    }
})
